import LayerGroup from 'ol/layer/Group';
import TileWMS from 'ol/source/TileWMS';
import VectorLayer from 'ol/layer/Vector';
import { proyeccion3857, formatoSalidaJson, nombresColumnas } from "./configuracion";

const botonObtenerInformacion = document.getElementById('obtenerInformacion');
botonObtenerInformacion.addEventListener('click', function () {
    this.classList.toggle('active');

    if(!this.classList.contains('active'))
    {
        //Se puede eliminar los popup al desactivar.
    }
});

export function obtenerInformacion(e) {
    if(botonObtenerInformacion.classList.contains('active'))
    {
        const coordenadas = e.coordinate;
        const resolucionVista = /** @type {number} */ (global.vista.getResolution());
        let texto = `<table style="border-collapse: collapse; width: 100%;"><thead><tr><th></th><th></th></tr></thead><tbody>`;
        let promesas = [];

        global.gruposDeCapas.forEach(grupo => {
            if (grupo instanceof LayerGroup) {
                grupo.getLayers().forEach(layer => {
                    if (
                        layer.get('id') !== 'dibujoGeometria' &&
                        layer.getVisible() &&
                        layer.get('type') !== 'base' &&
                        layer.get('type') !== 'undefined'
                    )
                    {
                        const source = layer.getSource();
                        if (source instanceof TileWMS) {
                            const url = source.getFeatureInfoUrl(coordenadas, resolucionVista, proyeccion3857, { 'INFO_FORMAT': formatoSalidaJson });

                            if (url) {
                                promesas.push(
                                    fetch(url)
                                        .then(response => {
                                            if (!response.ok) {throw new Error(`HTTP error! status: ${response.status}`);}
                                            return response.json();
                                        })
                                        .then(data => {
                                            //console.log("Datos obtenidos del WMS:", data);
                                            if(data.features.length > 0)
                                            {
                                                const features = data.features[0].properties;
                                                let capa = layer.get('title');
                                                texto += `<tr><td colspan="2"><strong>Capa: <u>${capa}</u></strong></td></tr>`;
                                            
                                                if(capa.includes('Hidroperíodo'))
                                                {
                                                    Object.entries(features).forEach(([key, value])=>{
                                                    let columna = nombresColumnas.find(e => e.id === key);
                                                        if(columna){
                                                            if (columna.id === 'Value_Pixel' || columna.id === 'GRAY_INDEX') texto += `<tr><td>Número de días</td><td>${value}</td></tr>`;
                                                            else texto += `<tr><td><strong>${columna.nombre}:</strong></td><td>${value}</td></tr>`;      
                                                        }
                                                    });
                                                }
                                                else
                                                {
                                                    Object.entries(features).forEach(([key, value]) => {
                                                        let columna = nombresColumnas.find(e => e.id === key);
                                                        if (columna){
                                                            if (columna.id === 'Value_Pixel' || columna.id === 'GRAY_INDEX') {
                                                                let valor = value === 1 ? 'Sí' : 'No';
                                                                texto += `<tr><td><strong>${columna.nombre}: </strong></td><td>${valor}</td></tr>`;
                                                            } else texto += `<tr><td><strong>${columna.nombre}: </strong></td><td>${value}</td></tr>`;        
                                                        }
                                                    });
                                                }
                                            }                                        
                                        })
                                        .catch(error => console.error('Error al obtener GetFeatureInfo:', error))
                                );
                            }
                        } else if (source instanceof VectorLayer) {
                            const features = source.getFeatures();
                            features.forEach(feature => {
                                const geometry = feature.getGeometry();
                                if (geometry.intersectsCoordinate(coordenadas)) {
                                    const properties = feature.getProperties();
                                    const filteredProperties = { ...properties };
                                    delete filteredProperties.geometry;

                                    texto += `<tr><td colspan="2"><strong>Capa: <u>${layer.get('title')}</u></strong></td></tr>`;
                                    texto += Object.entries(filteredProperties)
                                        .map(([key, value]) => `<tr><td><strong>${key}: </strong></td><td>${value}</td></tr>`)
                                        .join('');
                                }
                            });
                        }
                    }
                });
            } else {
                console.log('El objeto no es un grupo de capas:', grupo);
            }
        });

        Promise.all(promesas).then(() => {
            texto += '</tbody></table>';
            global.contenido.innerHTML = texto;
            global.overlay.setPosition(coordenadas);
        }).catch(error => {
            console.error("Error al procesar las capas visibles:", error);
        });
    }
}